<template>
  <div>
    <vehicle-add></vehicle-add>
  </div>
</template>

<script>
import VehicleAdd from './VehicleAdd.vue';

export default {
  components: {
    VehicleAdd,
  },

  data() {
    return {};
  },
};
</script>
